<template>
  <nav
    id="sidebar"
    class="bg-dark vh-100"
    :class="{ 'd-lg-block': isVisible, 'd-none': !isVisible }"
  >
    <div class="sidebar-header p-3 text-center text-white">
      <h4>My App</h4>
    </div>
    <ul class="list-unstyled">
      <li class="sidebar-item">
        <router-link to="/dashboard" class="text-white nav-link">
          <i class="bi bi-speedometer2 me-2"></i> Dashboard
        </router-link>
      </li>
      <li class="sidebar-item">
        <router-link to="/Page" class="text-white nav-link">
          <i class="bi bi-person-circle me-2"></i> Page
        </router-link>
      </li>
<!--      <li class="sidebar-item">-->
<!--        <router-link to="/component" class="text-white nav-link">-->
<!--          <i class="bi bi-person-circle me-2"></i> Component-->
<!--        </router-link>-->
<!--      </li>-->
<!--      <li class="sidebar-item">-->
<!--        <router-link to="/profile" class="text-white nav-link">-->
<!--          <i class="bi bi-person-circle me-2"></i> Profile-->
<!--        </router-link>-->
<!--      </li>-->
      <li class="sidebar-item">
        <router-link to="/product" class="text-white nav-link">
          <i class="bi bi-gear-fill me-2"></i> Product
        </router-link>
      </li>
      <li class="sidebar-item">
        <router-link to="/category" class="text-white nav-link">
          <i class="bi bi-gear-fill me-2"></i> Category
        </router-link>
      </li>
      <li class="sidebar-item">
        <router-link to="/image" class="text-white nav-link">
          <i class="bi bi-gear-fill me-2"></i> Images
        </router-link>
      </li>
      <li class="sidebar-item">
        <router-link to="/download" class="text-white nav-link">
          <i class="bi bi-gear-fill me-2"></i> Downloadable
        </router-link>
      </li>
      <li class="sidebar-item">
        <router-link to="/newsletter" class="text-white nav-link">
          <i class="bi bi-gear-fill me-2"></i> Newsletter
        </router-link>
      </li>
      <li class="sidebar-item">
        <router-link to="/settings" class="text-white nav-link">
          <i class="bi bi-gear-fill me-2"></i> Settings
        </router-link>
      </li>
      <li class="sidebar-item">
        <a href="#" @click="clear_cache" class="text-white nav-link">
          <i class="bi bi-box-arrow-right me-2"></i> Clear Cache
        </a>
      </li>
      <li class="sidebar-item">
        <a href="/logout" class="text-white nav-link">
          <i class="bi bi-box-arrow-right me-2"></i> Logout
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
import axios from "axios";

export default {
  name: "SideBar",
  props: {
    isVisible: {
      type: Boolean,
      default: true,
    },
  },
  methods:{
    async clear_cache(){
      const response = await axios.get('/dashboard/clear-cache/');
      if(response){
        alert('Cache Cleared Successfully.')
      }
    }
  }
};
</script>

<style scoped>
#sidebar {
  width: 250px;
  transition: transform 0.3s ease, background-color 0.3s ease;
  background-color: #343a40;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
}

.sidebar-header {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.sidebar-item {
  padding: 10px 15px;
}

.sidebar-item .nav-link {
  display: flex;
  align-items: center;
  padding: 10px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 4px;
  transition: background-color 0.3s, color 0.3s;
}

.sidebar-item .nav-link:hover {
  background-color: #495057;
  color: #ffffff;
}

.sidebar-item .nav-link i {
  font-size: 18px;
}
</style>
